import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import faGear from "../../fontawesome/pro-light-svg-icons/faGear";

export const SettingsButton = () => {
    const navigate = useNavigate();

    return (
        <button
            onClick={() => navigate("/settings")}
            style={{
                position: "fixed",
                bottom: 16,
                right: 16,
                background: "#0D6EFD",
                border: "none",
                borderRadius: 8,
                padding: 12,
                color: "white",
                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                zIndex: 1000,
            }}
        >
            <FontAwesomeIcon icon={faGear} size="lg" />
        </button>
    );
};
